module.exports = __webpack_public_path__ + "static/media/medals.cdbba367.png";